<script setup lang="ts">
import { watchEffect } from "vue";
import { useRouter } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import Loading from "@/components/shared/Loading.vue";
import { useCanAccessOfficesManagement } from "@/composables/shared/useSectionPermissions";
import {
  ORGANIZATION_LEVEL_PATHS,
  useMyOrganization,
} from "@/composables/shared/useMyOrganization";

definePage({
  meta: {
    title: "generic.entity.organization",
    checkPrivileges: () => useCanAccessOfficesManagement().value,
  },
});

const router = useRouter();
const { isResolved, routeForLevel } = useMyOrganization();

watchEffect(() => {
  if (!isResolved.value) return;

  router.replace(routeForLevel("dso") ?? ORGANIZATION_LEVEL_PATHS.practices);
});
</script>

<template>
  <Loading
    :size="32"
    class="tw:my-6!"
  />
</template>
